export const rejectResponseAbove = (httpCode) => async (response) => {
  if (response.status >= 400) {
    const json = await response.json()
    throw new Error(json.errors.message)
  }
  return response
}

function errorsToSingleMessage(errors) {
  if (errors.length < 2) {
    return errors[0].message
  }

  return errors.reduce(
    (msg, error, index) => `${msg}${index > 1 ? ' and' : ' '}${error.message}`,
    `Several errors happened:`
  )
}

export function interceptGraphQLErrors(response) {
  if (response.errors) {
    throw new Error(errorsToSingleMessage(response.errors))
  }
  return response
}
